<template>

  <div class="summary" v-if="($store.getters.getPermissions?.viewComments === true) || ($store.getters.getPermissions?.permissionGod === true)">
    <div class="tab">
      <span
          v-if="$store.getters.getPermissions?.viewComments === true"
          class="tab_title"
          :class="{ active : block==='Comments'}"
          @click="selected_block('Comments')">
        {{ translate('summary.comments.title')}}
      </span>
      <span
          v-if="$store.getters.getPermissions?.permissionGod === true && view_history"
          class="tab_title"
          :class="{ active : block==='HistoryAction'}"
          @click="selected_block('HistoryAction')"
      >
        {{ translate('summary.actions.title')}}
      </span>
    </div>
    <div class="block">
      <Comments
        v-if="block==='Comments'"
        :params="comments_params"
      />
      <HistoryAction
        v-if="block==='HistoryAction'"
        :type="type"
        :params="actions_params"
      />
    </div>
  </div>

</template>
<script>

import Comments from "./Tabs/Comments/Index.vue";
import HistoryAction from "./Tabs/HistoryAction/Index.vue";

export default {
  name: 'Summary',
  props: {
    type: {
      type: String,
      required: true
    },
    info: {
      type: Object,
      required: true
    },
    view_history:{
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    Comments,
    HistoryAction
  },
  data () {
    return {
      block: 'Comments',
    }
  },
  computed:{
    comments_params(){
      switch (this.type) {
        case 'device': return { device_id: this.info.id };
        case 'simcard_devices': return { device_simcard_id: this.info.id };
        case 'simcard_profile': return { simcard_profile_id: this.info.id };
        case 'esim_profile': return { esim_profile_id: this.info.id };
        case 'project': return { project_id: this.info.id };
        case 'client_order': return { client_order_id: this.info.id };
        case 'server': return { server_id: this.info.id };
        case 'client_request': return { client_request_id: this.info.id };
        case 'client': return { client_id: this.info.id };
        case "invoice": return { client_invoice_id: this.info.id };
        case "tariff": return { tariff_id: this.info.id};
        case "ip_address": return { ip_address_id: this.info.id};
        case "tariffed_device": return { tariffed_device_id: this.info.id};
        case "user": return { user_id: this.info.id};
        case "specification": return { client_order_spec_id: this.info.id};
        case "ticket": return { ticket_id: this.info.id };
        case "diadoc_document": return { diadoc_id: this.info.id }
        case "rpc_template": return { rpc_template_id: this.info.id }
        case "apn": return { simcard_operator_apn_id: this.info.id }
      }
    },
    actions_params(){
      switch (this.type) {
        case 'device': return { device_id: this.info.id };
        case 'simcard_devices': return { simcard_id: this.info.id };
        case 'simcard_profile': return {imsi: this.info.imsi, iccid: this.info.iccid};
        case 'esim_profile': return {imsi: this.info.imsi, iccid: this.info.iccid};
        case 'project': return { project_id: this.info.id };
        case 'client_order': return { client_order_id: this.info.id };
        case 'server': return { server_id: this.info.id };
        case 'client_request': return { client_request_id: this.info.id };
        case 'client': return { client_id: this.info.id };
        case "invoice": return { client_invoice_id: this.info.id };
        case "tariff": return { tariff_id: this.info.id};
        case "ip_address": return { ip_address_id: this.info.id};
        case "tariffed_device": return { tariffed_device_id: this.info.id};
        case "user": return { user_id: this.info.id};
        case "specification": return { client_order_spec_id: this.info.id};
        case "ticket": return { ticket_id: this.info.id };
        case "diadoc_document": return { diadoc_id: this.info.id }
      }
    }
  },
  methods: {
    selected_block(block){
      this.block = block
    }
  }
}
</script>

<style lang='scss' scoped>
.summary{
  height: 100%;
  .tab{
    width: 100%;
    height: 30px;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: row;
    &_title{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      background-color: #efe9e9;
      border: 1px solid #efe9e9;
      &.active{
        background-color: #f8f8f8;
        border-bottom: 1px solid #f8f8f8;
      }
    }
  }
  .block{
    height: 95%;
    border: 1px solid #efe9e9;
    margin-top: -1px;
    padding: 10px;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }
}

@media (max-width: 1200px) {
  .summary {
    height: 100%;

    .block {
      overflow: inherit;
    }
  }
}

</style>
